import {KeycloakWrapperService} from '../keycloak/keycloak-wrapper.service';
import {AuthService} from '../../services/auth.service';
import {DialogService} from '../../services/dialog.service';
import {inject} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {catchError, from, Observable, switchMap, throwError} from 'rxjs';

export function logoutFromExpiredSession(_authService: AuthService, _dialogService: DialogService): void {
    const dialogContent = _dialogService.getNewDialogContent('error', 'ERROR.EXPIRED_SESSION', null, 'ERROR.EXPIRED_SESSION_MSG');
    dialogContent.override = true;
    _dialogService.openInfoDialog(dialogContent);
    setTimeout(() => _authService.logout(), 2500);
}

export function  handle401Error(request: HttpRequest<any>, next: HttpHandlerFn, _kcService: KeycloakWrapperService, _authService: AuthService, _dialogService: DialogService): Observable<HttpEvent<unknown>> {
    if (!_authService.isRefreshing) {
        _authService.isRefreshing = true;
        return from(_kcService.updateToken()).pipe(
            switchMap(() => {
                _authService.isRefreshing = false;
                return next((request));
            }),
            catchError((e) => {
                _authService.isRefreshing = false;
                logoutFromExpiredSession(_authService, _dialogService);
                return throwError(() => e);
            })
        );
    }
    return next(request);
}

export const includeUnAuthInterceptor: (req: HttpRequest<unknown>, next: HttpHandlerFn) => Observable<HttpEvent<unknown>>
= (req, next) => {
    const _kcService: KeycloakWrapperService = inject(KeycloakWrapperService);
    const _authService: AuthService = inject(AuthService);
    const _dialogService: DialogService = inject(DialogService);
    return next(req).pipe(catchError((e) => {
        const originReq = req;
        console.log('21121',e);
        console.log(originReq);
        console.log(originReq.headers);
        if (e instanceof HttpErrorResponse && e.status === 401) {
            console.log('21122',e);
            return handle401Error(originReq, next, _kcService, _authService, _dialogService);
        }
        return throwError(() => e);
    }));
};